module.exports = __webpack_public_path__ + "static/community-right-468bf75a1b44084868445408b65854d1.webp";